import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { TeamService } from '../../../team-edit/services/team.service';
import { PitchList, Variant } from 'src/app/shared/models/type-list';
import { FormGroup, FormBuilder, Form, Validators, ValidatorFn, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
@Component({
    selector: 'transfer-pitch-dialog',
    templateUrl: './transfer-pitch-dialog.html',
    styleUrls: ['./transfer-pitch-dialog.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, NgFor, MatOption, NgIf, MatProgressSpinner, MatDialogActions, MatButton]
})
export class TransferPitchDialog implements OnInit {
  plantName: string;
  fromPitches: PitchList[] = [];
  toPitches: PitchList[] = [];
  fromPitchVariant: Variant[] = [];
  toPitchVariant: Variant[] = [];

  transferGroup: FormGroup;

  fromPitch: PitchList = <PitchList>{};
  fromPitchID: number = 0;
  ToPitch: PitchList = <PitchList>{};
  toPitchID: number = 0;
  fromVariantID: number = 0;
  toVariantID: number = 0;
  teamID: number = 0;
  versionID: number = 0;
  transferEnable:boolean = false;
  samePitchVarSel:boolean= false;
  workBeingDeletedWarning: boolean = false;
  waiting: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<TransferPitchDialog>,
    @Inject(MAT_DIALOG_DATA) public pitchWorkData: PitchWorkData,
    private teamService: TeamService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.pitchWorkData.plant_name ? this.plantName = this.pitchWorkData.plant_name: this.plantName = '';
    this.pitchWorkData.pitch_list ? this.fromPitches = this.pitchWorkData.pitch_list: this.fromPitches = [];
    this.pitchWorkData.pitch_list ? this.toPitches = this.pitchWorkData.pitch_list: this.toPitches = [];

    console.log(this.fromPitches)

    this.transferGroup = this.fb.group({
      f_fromPitch: [(this.fromPitchID == 0) ? 0: this.fromPitchID],
      f_fromVariant: [(this.fromVariantID == 0) ? 0: this.fromVariantID],
      f_toPitch: [(this.toPitchID == 0) ? 0: this.toPitchID],
      f_toVariant: [(this.toVariantID == 0) ? 0: this.toVariantID]
    })

    this.transferGroup.valueChanges.subscribe((values) =>{
      this.fromPitchID = values.f_fromPitch,
      this.fromVariantID = values.f_fromVariant,
      this.toPitchID = values.f_toPitch
    });

    this.transferGroup.controls['f_fromPitch'].valueChanges.subscribe((value) => {
      this.fromPitchVariant = []
      this.transferGroup.get('f_fromVariant')?.setValue('');
      this.fromVariantID = 0;
      let pitchIndex = this.fromPitches.findIndex(pitch => pitch.pitch_config_id === value)

      this.teamID = this.toPitches[pitchIndex].team_id;
      this.versionID = this.toPitches[pitchIndex].version_id;

      this.fromPitches[pitchIndex].variantDetails.forEach(variant=> {
          let pitchVariant: Variant = 
          {
            "team_id": this.fromPitches[pitchIndex].team_id,
            "variant_id": variant.variant_id,
            "variant_name": variant.variant_name,
            "total_work": variant.total_work
          }
          this.fromPitchVariant.push(pitchVariant)
        }
      )      
    })

    this.transferGroup.controls['f_toPitch'].valueChanges.subscribe((value) => {
      this.toPitchVariant = []
      this.transferGroup.get('f_toVariant')?.setValue('');
      this.toVariantID = 0;
      
      let pitchIndex = this.toPitches.findIndex(pitch => pitch.pitch_config_id === value);

      this.toPitches[pitchIndex].variantDetails.forEach(variant=> {
          let pitchVariant: Variant = 
          {
            "team_id": this.toPitches[pitchIndex].team_id,
            "variant_id": variant.variant_id,
            "variant_name": variant.variant_name,
            "total_work": variant.total_work
          }
          this.toPitchVariant.push(pitchVariant)
        }
      )        
    })

    this.transferGroup.valueChanges.subscribe((value)=>{
      this.samePitchVarSel = false;
      if ((this.toPitchID != 0 && this.fromPitchID != 0 && this.fromVariantID != 0 && this.toVariantID != 0) && this.transferGroup.status == "VALID") {
        this.transferEnable = true;
      }
      else {
        this.transferEnable  = false;
      }
    })

    this.transferGroup.controls['f_toVariant'].valueChanges.subscribe(value => {  
      this.toVariantID = value; 
      this.checkWorkBeingDeleted(); 
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkWorkBeingDeleted() {
    this.workBeingDeletedWarning = false;
    if (this.toPitchID && this.toVariantID) {
      const selectedToPitch = this.toPitches.find(pitch => pitch.pitch_config_id === this.toPitchID);
      if (selectedToPitch) {
        const selectedToVariant = selectedToPitch.variantDetails.find(variant => variant.variant_id === this.toVariantID);
        if (selectedToVariant && selectedToVariant.total_work && selectedToVariant.total_work > 0) {
          this.workBeingDeletedWarning = true;
        }
      }
    }
  }

  submitTransfer(){
    if ((this.toPitchID == this.fromPitchID && this.fromVariantID == this.toVariantID)){
      this.samePitchVarSel = true;
      return;
    }
    
    else
    {      
      this.waiting = true;
      this.teamService.transferPitchWork(this.plantName, this.teamID, this.versionID, this.fromPitchID, this.fromVariantID, this.toPitchID, this.toVariantID).subscribe(out=>{
        this.waiting = false;
        this.dialogRef.close(true)
      });
    }
  }

}

export interface PitchWorkData {
  plant_name: string;
  pitch_list: PitchList[];
}